import { get, put } from '.';

export const sendRequestAccess = () => put(`/api/v1/toAccesRequest/`);
export const getRequestAccess = () => get(`/api/v1/toAccesRequest/`);
